import React from 'react';
import { TabsNavItemCore, } from '@core-front/tabs';
import Anchor from '@telia-front/anchor';
import Fittext from '@telia-front/fittext';
import Icon from '@telia-front/icon';
import Image from '@telia-front/image';
import Tag from '@telia-front/tag';
import { TabsContext } from './tabs-context';
const TabsNavItem = (props) => {
    const { size } = React.useContext(TabsContext);
    const BEM = () => {
        const classArray = [];
        if (props.icon) {
            classArray.push('tabs__nav-item--icon');
        }
        if (props.type && typeof getType() === 'undefined') {
            classArray.push(`tabs__nav-item--${props.type}`);
        }
        if (props.className) {
            classArray.push(props.className);
        }
        return classArray.join(' ');
    };
    const getType = () => {
        switch (props.type) {
            case 'recommended':
                return undefined;
            default:
                return props.type;
        }
    };
    return (React.createElement(TabsNavItemCore, Object.assign({}, props, { type: getType(), className: BEM(), components: {
            Anchor,
            Icon,
        } }),
        props.image && React.createElement(Image, Object.assign({}, props.image, { className: "tabs__nav-item-image" })),
        React.createElement("div", { className: "tabs__nav-item-content" },
            size === 'huge' ? React.createElement(Fittext, null, props.text) : React.createElement("div", { className: "tabs__nav-link-inner" }, props.text),
            props.tagContent && (React.createElement(Tag, { size: "tiny", text: props.tagContent, purpose: props.type && ['employee', 'recommended'].includes(props.type) ? props.type : 'primary', className: "tabs__nav-item-tag" })))));
};
export { TabsNavItem as default, };
